import { appLogo, examName } from "@constants/demo";
import { buildType } from "@helpers/expo-extras";
import { Apps } from "types/apps";

type DefaultExamContext = {
	studyPackProductId: string;
	examName: string;
	examId: string;
	examIcon?: string;
	studyPackProductNumericId: number;
	practiceTestProductId?: string;
	practiceTestProductNumericId?: number;
};
export const defaultExamContextMap: Record<Apps, DefaultExamContext> = {
	[Apps.TherapyEd]: {
		studyPackProductId: "952aca40-c93d-4656-8814-94264f293ac4",
		examName: "NPTE-PT",
		studyPackProductNumericId: 44,
		practiceTestProductId: "3f789553-1d7d-4049-9ceb-cb610e83e102",
		examId: "e61873a5-ffd7-4bed-9745-256da36a16d7",
		examIcon: "https://icon.memorang.com/icon/icon_exam_21.png",
		practiceTestProductNumericId: 66,
	},
	[Apps.Psi]: {
		studyPackProductId: "031ed055-d3a3-4a67-9048-5d9658454865",
		examName: "Life Accident and Health",
		studyPackProductNumericId: 45,
		practiceTestProductId: "8b8d2b39-1780-4b8c-a270-08053153cad3",
		examId: "c2dc2f42-ccbe-428a-81ed-0d45a5b2f001",
		examIcon: "https://icon.memorang.com/icon/icon_exam_1.png",
		practiceTestProductNumericId: 72,
	},
	[Apps.hiset]: {
		studyPackProductId: "031ed055-d3a3-4a67-9048-5d9658454865",
		examName: "Life Accident and Health",
		studyPackProductNumericId: 45,
		examId: "c2dc2f42-ccbe-428a-81ed-0d45a5b2f001",
		examIcon: "https://icon.memorang.com/icon/icon_exam_1.png",
	},
	[Apps.Simwerx]: {
		studyPackProductId: "c625da7a-b90c-4eb1-98e0-746bdb804633",
		examName: "Simwerx",
		studyPackProductNumericId: 103,
		examId: "4e85d959-d7c0-4714-89bd-057030d6dbc6",
	},
	[Apps.Jbjs]: {
		studyPackProductId: "226e77c4-b1ca-4216-9e36-2ba07182f76f",
		examName: "JBJS",
		studyPackProductNumericId: 105,
		examId: "",
	},
	[Apps.Ada]: {
		studyPackProductId: "226e77c4-b1ca-4216-9e36-2ba07182f76g",
		examName: "ADA",
		studyPackProductNumericId: 106,
		examId: "",
	},
	[Apps.zoetis]: {
		studyPackProductId: "226e77c4-b1ca-4216-9e36-2ba07182f76k",
		examName: "Zoetis",
		studyPackProductNumericId: 107,
		examId: "",
	},
	[Apps.thiemeneetpg]: {
		studyPackProductId: "fb00db47-e102-4362-9bcb-f2959b8ccedd",
		examName: "NEET PG",
		studyPackProductNumericId: 128,
		examId: "26560f9a-49b4-4440-b5e4-05ac8d5973f4",
		examIcon: "https://icon.memorang.com/icon/icon_exam_26.png",
	},
	[Apps.Toefl]: {
		studyPackProductId: "226e77c4-b1ca-4216-9e36-2ba07182f76l",
		examName: examName,
		studyPackProductNumericId: 129,
		examId: "26560f9a-49b4-4440-b5e4-05ac8d5973f4",
		examIcon: appLogo,
	},
	[Apps.Proethica]: {
		studyPackProductId: "226e77c4-b1ca-4216-9e36-2ba07182f76l",
		examName: "PRAXIS PROETHICA",
		studyPackProductNumericId: 129,
		examId: "proethica",
		examIcon:
			"https://staging-services.memorang.com/storage/v1/object/public/memorang-assets/acme/icon_dark.png",
	},
};

export const defaultExamContext = defaultExamContextMap[buildType];
